import type { ComponentType } from 'react';

import { cn } from '~/utils/cn';

/** Minimal shape of a `simple-icons` icon export (title, brand hex, SVG path). */
interface SimpleIcon {
  title: string;
  hex: string;
  path: string;
}

/**
 * Builds a brand-logo component from a `simple-icons` icon object — a single
 * 24×24 path filled with the brand's official hex. Used to bundle connector
 * marks the backend doesn't supply an `iconUrl` for.
 */
export function makeSimpleIconLogo(icon: SimpleIcon): ComponentType<{ className?: string }> {
  function SimpleIconLogo({ className }: { className?: string }) {
    return (
      <svg
        role="img"
        aria-hidden="true"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        fill={`#${icon.hex}`}
        className={cn('h-8 w-8 shrink-0', className)}
      >
        <path d={icon.path} />
      </svg>
    );
  }
  SimpleIconLogo.displayName = `${icon.title.replace(/\s+/g, '')}Logo`;
  return SimpleIconLogo;
}
